import { NameMatch } from '../translations-types';

const translations: NameMatch = {
  title: 'Clientname matching',
  description:
    'Upload a CSV with email and name. The list is matched by email against your Re-sence customers; differing names can be applied with one click.',
  selectFile: 'Choose CSV',
  loadingCustomers: 'Loading customers…',
  summary: 'Summary',
  discrepancies: 'Differences',
  notFound: 'Not found',
  identical: 'Identical',
  email: 'Email',
  currentName: 'Current name',
  newName: 'New name (CSV)',
  apply: 'Apply',
  applyError: 'Failed',
  status: 'Status',
  noDiscrepancies: 'No differences found.',
  parseError: 'Could not read the CSV file.',
  emptyFile: 'The file contains no rows.',
  missingColumns: 'The CSV is missing an email or name column.',
  notFoundHint: 'These emails from the CSV are not present in Re-sence.',
};

export default translations;
